module.exports = __webpack_public_path__ + "static/assets/af283a610763d85c4543b272cb27e263.svg";